import styles from './styles.module.scss';

interface FormControlProps extends React.HTMLAttributes<HTMLDivElement> {
    wrapperClass?: string;
    label: JSX.Element | string;
    inputId: string;
    flexDirection: 'column' | 'row' | 'row-reverse';
}

export const FormControl = ({
    wrapperClass,
    label,
    inputId,
    flexDirection = 'column',
    children,
    ...rest
}: FormControlProps) => {
    return (
        <div
            className={`${wrapperClass ?? ''} ${styles.wrapper} ${styles[flexDirection]}`}
            {...rest}
        >
            <label
                className={`${styles.label} ${['row'].includes(flexDirection) && styles.labelRow}`}
                htmlFor={inputId}
            >
                {label}
            </label>
            {children}
        </div>
    );
};
